<template>
  <Checkbox
    :is-checked='isChecked'
    class='filter-option'
    @update:is-checked='syncOption'
  >
    <span>{{ label }}</span>
    <span v-if='discount' class='discount'>{{ discountPercent }}</span>
    <span v-if='isNew' class='new'>
      <NewIcon />{{ i18nT('option.new') }}
    </span>
    <span v-if='markerClass' :class='markerClass' :style='markerStyle' />
  </Checkbox>
</template>

<script>
export default {
  name: 'DropdownFilterOption',
  inheritAttrs: false
};
</script>

<script setup>
import { computed } from 'vue';

import Checkbox from '../checkbox';
import NewIcon from '@/../images/vue/storages_map-v4/dropdown_filter/new.svg?inline';

const props = defineProps({
  label: { type: String, required: true },
  isChecked: { type: Boolean, required: true },
  discount: { type: String, required: false, default: undefined },
  isNew: { type: Boolean, required: false },
  markerClass: { type: String, required: false, default: undefined },
  markerStyle: { type: Object, required: false, default: undefined },
  i18nT: { type: Function, required: false, default: undefined }
});
const emit = defineEmits(['update:isChecked']);

const discountPercent = computed(() => (
  props.discount?.replace(/.*(-[\d.]+%).*/, '$1')
));

function syncOption(isChecked) {
  emit('update:isChecked', isChecked);
}
</script>

<style scoped lang='sass'>
@import 'app/packs/stylesheets/functions/rem'
@import 'app/packs/stylesheets/mixins/ltr_rtl'
@import 'app/packs/stylesheets/mixins/responsive'

.filter-option
  align-items: center
  color: var(--text-strong)
  cursor: pointer
  display: flex
  flex-shrink: 0
  font-weight: 600
  line-height: 1.25
  transition: background var(--transition-duration)

  +lte_ipad
    font-size: rem4(16px)
    gap: rem4(8px)
    height: rem4(40px)
    padding: 0 var(--container-padding-x)

  +gte_laptop
    border-radius: 12px
    font-size: 16px
    gap: 8px
    height: 40px
    padding: 0 12px

    &:hover
      background: #f3f4f6

  &:active
    background: #f3f4f6

  .discount
    background: rgba(80, 150, 255, 0.10)
    color: #3178e2
    font-weight: 700
    line-height: 1.3

    +lte_ipad
      border-radius: rem4(16px)
      font-size: rem4(14px)
      padding: rem4(4px) rem4(8px)

    +gte_laptop
      border-radius: 16px
      font-size: 14px
      padding: 4px 8px

  .new
    align-items: center
    align-self: flex-end
    color: #5096FF
    display: inline-flex
    font-weight: 700
    justify-content: center
    line-height: 1.2

    +lte_ipad
      font-size: rem4(12px)
      gap: rem4(4px)

    +gte_laptop
      font-size: 12px
      gap: 4px

    svg
      +lte_ipad
        height: rem4(16px)
        width: rem4(16px)

      +gte_laptop
        height: 16px
        width: 16px
</style>
